<script setup lang="ts">
import type { CheckboxProps } from '@formwerk/core'
import { useCheckbox, useFormContext } from '@formwerk/core'

const props = defineProps<CheckboxProps<string>>()

const { labelProps, inputProps, errorMessage, errorMessageProps, isChecked, isBlurred }
  = useCheckbox(props)

// Inside a form, errors only show after a submit attempt, then update live as the user fixes them
const form = useFormContext()
const errored = computed(() => (form ? form.isSubmitAttempted.value : isBlurred.value) && !!errorMessage.value)
</script>

<template>
  <div>
    <label
      v-bind="labelProps"
      class="inline-flex gap-1.5 cursor-pointer select-none items-start has-[:disabled]:opacity-50 has-[:disabled]:cursor-not-allowed"
      :class="{ 'c-red': errored }"
    >
      <input v-bind="inputProps" class="sr-only">

      <div
        class="motion-snug border border-current/30 flex shrink-0 size-4 items-center justify-center has-checked:border-current"
      >
        <svg
          v-show="isChecked"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 256 256"
          class="size-3.5 absolute fill-current"
        >
          <path d="M232.49,80.49l-128,128a12,12,0,0,1-17,0l-56-56a12,12,0,1,1,17-17L96,183,215.51,63.51a12,12,0,0,1,17,17Z" />
        </svg>
      </div>

      <span class="typo-sans-1 uppercase -mt-px">
        {{ label }}
      </span>
    </label>

    <TransitionDefault>
      <p
        v-if="errored"
        v-bind="errorMessageProps"
        class="text-red-500 typo-sans-1 mt-1"
      >
        {{ errorMessage }}
      </p>
    </TransitionDefault>
  </div>
</template>
